
import { Component, Vue } from "vue-property-decorator";
import { Validations } from "vuelidate-property-decorators";
import { required } from "vuelidate/lib/validators";

@Component
export default class MixinMemberEditDialogValidator extends Vue {
  @Validations()
  validations = {
    item: {
      //氏名
      name: { required },
    },
  };
  //---------------------------
  // methods
  //---------------------------

  /**
   * 氏名の入力エラーメッセージを返します.
   */
  get nameErrors(): string[] {
    const errors: string[] = [];
    if (!this.$v.item.name?.$dirty) return errors;
    !this.$v.item.name?.required && errors.push("氏名を入力してください.");
    return errors;
  }
}
